/**
 * A fresh idempotency key for a grant / write that the service de-duplicates on. The same key is re-sent
 * when the admin retries the SAME form after an error, so a double submit is applied once; a new key is
 * minted only after a success or when the inputs change.
 *
 * `crypto.randomUUID` needs a secure context; the console may be served over plain http on a LAN, so the
 * fallback builds a v4 UUID from `getRandomValues`, which has no such restriction.
 */
export function newIdempotencyKey(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === 'function') {
    try {
      return c.randomUUID();
    } catch {
      /* insecure context — fall through */
    }
  }

  const bytes = new Uint8Array(16);
  if (c && typeof c.getRandomValues === 'function') {
    c.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
  }
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
